//#region src/compat/util/stubTrue.ts
function stubTrue() {
	return true;
}
//#endregion
export { stubTrue };
